export default __webpack_public_path__ + "static/media/rhombus.05d7f59c.png";